import { render, staticRenderFns } from "./Auditoria-en-seguros.vue?vue&type=template&id=b5c58fba&scoped=true&"
import script from "./Auditoria-en-seguros.vue?vue&type=script&lang=js&"
export * from "./Auditoria-en-seguros.vue?vue&type=script&lang=js&"
import style0 from "./Auditoria-en-seguros.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Auditoria-en-seguros.vue?vue&type=style&index=1&id=b5c58fba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5c58fba",
  null
  
)

export default component.exports